import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState, useEffect, useRef } from 'react';
import { Platform, PanResponder } from 'react-native';
import { Popup } from '../../Popup/rn';
import { MaskType, RichText } from '../../RichText/rn';
import { RichTextInWebView } from '../../RichText/rn/RichTextInWebView';
import ArrowDown from '../../../assets/images/rn/KeyAnswerArrow';
import WarnCircle from '../../../assets/images/rn/WarnCircle';
import { Pressable, View, Text, Animated, Easing, Dimensions } from 'react-native';
import styles from './styles';
import { BubbleInnerWidth } from '../../../styles/rn';
import { getScaledPx } from '../../../utils/rn/tools';
import UiOptimisationRecommenderRightArrow from '../../../assets/images/rn/UiOptimisationRecommenderRightArrow';
import { emitTrackingEvent, useTracking } from '../../../hooks/rn/useTracking';
import { TRACKING_SECTION } from '../../../utils/tracking/constants';
import { debounce } from '../../../utils/lodashReplacement';
import { richTextTouchEndDebounceTime } from '../../../utils/constants';
export var KeyAnswerStatus;
(function (KeyAnswerStatus) {
  KeyAnswerStatus["LOADING"] = "LOADING";
  KeyAnswerStatus["ERROR"] = "ERROR";
  KeyAnswerStatus["FINISH"] = "FINISH";
})(KeyAnswerStatus || (KeyAnswerStatus = {}));
var KEY_ANSWER_TRACKER_SCOPE = 'key_answer_scope';
var FAQList = function FAQList(props) {
  var PREFIX = props.PREFIX,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    onClickFaq = props.onClickFaq,
    disabledFaq = props.disabledFaq,
    _props$styles = props.styles,
    stylesProps = _props$styles === void 0 ? {} : _props$styles,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender,
    inDetail = props.inDetail;
  var renderFAQItem = function renderFAQItem(faq, index) {
    var _useTracking = useTracking({
        trackingData: props.trackingData,
        componentData: _objectSpread(_objectSpread({}, faq), {}, {
          location: index
        }),
        scope: KEY_ANSWER_TRACKER_SCOPE
      }),
      trackingClick = _useTracking.trackingClick,
      trackingImpressionProps = _useTracking.trackingImpressionProps;
    var faqItemText = /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 2,
      ellipsizeMode: "tail",
      style: [styles["".concat(PREFIX, "-faq-item")], disabledFaq && styles["".concat(PREFIX, "-faq-item__disabled")], isUIOptimisationRecommender ? styles['key-answer-faq-ui-optimisation-item-text'] : {}]
    }, faq.text);
    return /*#__PURE__*/React.createElement(Pressable, _extends({
      onPress: function onPress() {
        // trackingClick && tracker.click(trackingClick);
        // 因为需要在点击时添加 next_chat_dialogue_id 这个 id 需要请求后才获得，所以把相应参数传回 C 端，那里触发点击上报
        onClickFaq === null || onClickFaq === void 0 ? void 0 : onClickFaq(faq, {
          trackingData: trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data,
          isInDetail: inDetail
        });
      }
    }, trackingImpressionProps), isUIOptimisationRecommender ? /*#__PURE__*/React.createElement(View, {
      style: [styles['key-answer-faq-ui-optimisation-item']]
    }, faqItemText, /*#__PURE__*/React.createElement(UiOptimisationRecommenderRightArrow, {
      style: {
        width: 12,
        height: 12,
        marginLeft: 8
      }
    })) : faqItemText);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, faqIntentList !== null && faqIntentList !== void 0 && faqIntentList.length ? /*#__PURE__*/React.createElement(View, {
    style: [styles["".concat(PREFIX, "-faq-container")], stylesProps, isUIOptimisationRecommender ? styles['key-answer-faq-ui-optimisation-container'] : {}, inDetail ? {
      marginTop: 12
    } : {}]
  }, faqTitle && /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 2,
    ellipsizeMode: "tail",
    style: [styles["".concat(PREFIX, "-faq-title")], isUIOptimisationRecommender ? styles['key-answer-faq-title'] : {}]
  }, faqTitle), /*#__PURE__*/React.createElement(View, null, faqIntentList.map(renderFAQItem))) : null);
};
var linearGradientHeight = 40;
export var SummaryMaxHeight;
(function (SummaryMaxHeight) {
  SummaryMaxHeight[SummaryMaxHeight["Full"] = 412] = "Full";
  SummaryMaxHeight[SummaryMaxHeight["Short"] = 252] = "Short";
})(SummaryMaxHeight || (SummaryMaxHeight = {}));
export var KeyAnswer = function KeyAnswer(props) {
  var _props$componentTrack, _props$componentTrack2;
  var PREFIX = 'keyAnswer';
  var _props$summaryMaxHeig = props.summaryMaxHeight,
    summaryMaxHeight = _props$summaryMaxHeig === void 0 ? SummaryMaxHeight.Short : _props$summaryMaxHeig,
    faqTitle = props.faqTitle,
    faqIntentList = props.faqIntentList,
    _props$viewMoreText = props.viewMoreText,
    viewMoreText = _props$viewMoreText === void 0 ? 'View More' : _props$viewMoreText,
    disabledFaq = props.disabledFaq,
    loadKeyAnswer = props.loadKeyAnswer,
    _props$failToLoadText = props.failToLoadText,
    failToLoadText = _props$failToLoadText === void 0 ? 'Fail to load article due to server error.' : _props$failToLoadText,
    _props$status = props.status,
    status = _props$status === void 0 ? KeyAnswerStatus.FINISH : _props$status,
    _props$summary = props.summary,
    summary = _props$summary === void 0 ? '' : _props$summary,
    _props$supportingMess = props.supportingMessage,
    supportingMessage = _props$supportingMess === void 0 ? '' : _props$supportingMess,
    richTextSize = props.richTextSize,
    _onWebViewSizeChange = props.onWebViewSizeChange,
    _props$unreadText = props.unreadText,
    unreadText = _props$unreadText === void 0 ? 'Unread' : _props$unreadText,
    _props$isAutoAdapt = props.isAutoAdapt,
    isAutoAdapt = _props$isAutoAdapt === void 0 ? false : _props$isAutoAdapt,
    _props$isScrollToUnre = props.isScrollToUnread,
    isScrollToUnread = _props$isScrollToUnre === void 0 ? false : _props$isScrollToUnre,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender,
    webViewKey = props.webViewKey,
    isFullSummary = props.isFullSummary,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationAccordion = props.isUIOptimisationAccordion,
    isUIOptimisationTable = props.isUIOptimisationTable,
    haveMinRichTextWidth = props.haveMinRichTextWidth;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    exceededMaxHeight = _useState2[0],
    setExceededMaxHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    scrollHeight = _useState4[0],
    setScrollHeight = _useState4[1]; // 最终需要滚动的高度

  var _useState5 = useState({
      index: 0,
      text: unreadText
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    unreadObj = _useState6[0],
    setUnreadObj = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showPopup = _useState8[0],
    setShowPopup = _useState8[1];
  var scrollViewRef = useRef(null);
  var scrollY = useRef(new Animated.Value(0)).current;
  var trackClosePopupRef = useRef({
    startTime: new Date(),
    articleScrolls: 0,
    articleScrollToEnd: false
  });
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    scrollEnabled = _useState10[0],
    setScrollEnabled = _useState10[1]; // const handleDisabledScroll = debounce(
  //   () => {
  //     setScrollEnabled(false);
  //   },
  //   100,
  //   { leading: true }
  // );

  var handleDisabledScroll = function handleDisabledScroll() {
    setScrollEnabled(false);
  };
  var handleRichTextTouchEnd = debounce(function () {
    setScrollEnabled(true);
  }, richTextTouchEndDebounceTime);
  var panResponder = useRef(PanResponder.create({
    // 处理开始滑动事件
    onStartShouldSetPanResponder: function onStartShouldSetPanResponder() {
      return true;
    },
    // 处理滑动事件
    onMoveShouldSetPanResponder: function onMoveShouldSetPanResponder(_, gestureState) {
      // 判断滑动方向是否为横向
      var isHorizontalSwipe = Math.abs(gestureState.dx) > Math.abs(gestureState.dy); // 如果是横向滑动，则禁止父级ScrollView的垂直滚动

      if (isHorizontalSwipe) {
        handleDisabledScroll();
        return true;
      } else {
        return false;
      }
    }
  })).current;
  var changeTrackClosePopupData = function changeTrackClosePopupData(data) {
    var oldTrackingData = trackClosePopupRef.current;
    trackClosePopupRef.current = _objectSpread(_objectSpread({}, oldTrackingData || {}), data || {});
  };
  var _ref = props.componentTrackingData || {},
    keyAnswerTracking = _ref.keyAnswer,
    closePopupTracking = _ref.closePopup;
  var _useTracking2 = useTracking({
      trackingData: keyAnswerTracking
    }),
    tracker = _useTracking2.tracker,
    trackingClick = _useTracking2.trackingClick,
    trackingImpressionProps = _useTracking2.trackingImpressionProps;
  var onClickFaq = function onClickFaq(faq, option) {
    var _props$onClickFaq;
    if (disabledFaq) {
      var _props$onClickDisable;
      (_props$onClickDisable = props.onClickDisabledFaq) === null || _props$onClickDisable === void 0 ? void 0 : _props$onClickDisable.call(props, faq);
      return;
    }
    if (showPopup) {
      setShowPopup(false);
    }
    (_props$onClickFaq = props.onClickFaq) === null || _props$onClickFaq === void 0 ? void 0 : _props$onClickFaq.call(props, faq, option);
  };
  var loadKeyAnswerContent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (loadKeyAnswer) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              loadKeyAnswer === null || loadKeyAnswer === void 0 ? void 0 : loadKeyAnswer();
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function loadKeyAnswerContent() {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClickViewMore = function onClickViewMore() {
    trackingClick && tracker.click(trackingClick);
    changeTrackClosePopupData({
      startTime: new Date(),
      articleScrolls: 0,
      articleScrollToEnd: false
    });
    setShowPopup(true);
  };
  var onClosePopup = function onClosePopup() {
    setShowPopup(false);
    if (closePopupTracking) {
      var trackClosePopupData = trackClosePopupRef.current;
      if (!trackClosePopupData.startTime) {
        return;
      }
      closePopupTracking.data = _objectSpread(_objectSpread({}, closePopupTracking.trackingdataBasic || {}), {}, {
        view_duration: Math.floor((new Date().getTime() - trackClosePopupData.startTime.getTime()) / 1000),
        key_answer_scrolls: trackClosePopupData.articleScrolls,
        key_answer_scroll_to_end: trackClosePopupData.articleScrollToEnd ? 0 : 1
      });
      tracker.click(closePopupTracking);
    }
  };
  useEffect(function () {
    if (status === KeyAnswerStatus.LOADING) {
      loadKeyAnswerContent();
    }
  }, [status]);
  useEffect(function () {
    scrollY === null || scrollY === void 0 ? void 0 : scrollY.addListener(function (animation) {
      var _scrollViewRef$curren;
      (_scrollViewRef$curren = scrollViewRef.current) === null || _scrollViewRef$curren === void 0 ? void 0 : _scrollViewRef$curren.scrollTo({
        y: animation.value,
        animated: true
      });
    });
    return function () {
      return scrollY.removeAllListeners();
    };
  }, []);
  useEffect(function () {
    if (showPopup && isScrollToUnread && scrollHeight > 0) {
      setTimeout(function () {
        // 滚动到指定位置
        Animated.timing(scrollY, {
          toValue: scrollHeight,
          // 滚动到位置
          duration: 400,
          // 动画持续时间
          // easing: Easing.in(Easing.ease),
          easing: Easing.cubic,
          useNativeDriver: true // 使用原生驱动器以提高性能
        }).start();
      }, 1500);
    } else {
      scrollY.setValue(0);
      var element = scrollViewRef.current;
      element === null || element === void 0 ? void 0 : element.scrollTo({
        y: 0,
        animated: true
      });
    }
  }, [showPopup, isScrollToUnread, scrollHeight]);
  var handleSummaryLayout = function handleSummaryLayout(contentHeight) {
    if (contentHeight >= summaryMaxHeight) {
      setExceededMaxHeight(true);
    } else {
      setExceededMaxHeight(false);
    }
  };
  if (status === KeyAnswerStatus.LOADING) {
    return /*#__PURE__*/React.createElement(View, {
      style: _objectSpread(_objectSpread({}, styles[PREFIX]), {}, {
        width: '100%'
      })
    }, /*#__PURE__*/React.createElement(View, {
      style: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "__loading")]), styles["".concat(PREFIX, "__loading1")])
    }), /*#__PURE__*/React.createElement(View, {
      style: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "__loading")]), styles["".concat(PREFIX, "__loading2")])
    }), /*#__PURE__*/React.createElement(View, {
      style: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "__loading")]), styles["".concat(PREFIX, "__loading3")])
    }));
  }
  if (status === KeyAnswerStatus.ERROR) {
    return /*#__PURE__*/React.createElement(View, {
      style: styles[PREFIX]
    }, /*#__PURE__*/React.createElement(View, {
      style: styles["".concat(PREFIX, "__error")]
    }, /*#__PURE__*/React.createElement(WarnCircle, {
      style: styles["".concat(PREFIX, "-prompt-icon")]
    }), /*#__PURE__*/React.createElement(Text, {
      style: styles["".concat(PREFIX, "-prompt-text")]
    }, failToLoadText)));
  }
  return /*#__PURE__*/React.createElement(View, _extends({
    style: styles[PREFIX]
  }, trackingImpressionProps), /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "-summary")]), {}, {
      maxHeight: summaryMaxHeight
    })
  }, /*#__PURE__*/React.createElement(RichText, {
    content: summary,
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    defaultWidth: getScaledPx(BubbleInnerWidth - 24),
    showLoading: false,
    richTextSize: richTextSize,
    onWebViewSizeChange: function onWebViewSizeChange(size) {
      _onWebViewSizeChange === null || _onWebViewSizeChange === void 0 ? void 0 : _onWebViewSizeChange(size);
      var contentHeight = size.height;
      handleSummaryLayout(contentHeight);
    },
    gradientOffsetTop: summaryMaxHeight - linearGradientHeight - 6,
    summaryMaxHeight: summaryMaxHeight,
    handleUnreadObjChange: function handleUnreadObjChange(val) {
      setUnreadObj(_objectSpread({
        text: unreadObj === null || unreadObj === void 0 ? void 0 : unreadObj.text
      }, val));
    },
    webViewKey: webViewKey,
    showMask: exceededMaxHeight,
    maskType: isFullSummary ? MaskType.KeyAnswerUI : MaskType.keyAnswerShortUI,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion
    },
    haveMinRichTextWidth: haveMinRichTextWidth
  })), exceededMaxHeight || supportingMessage ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Pressable, {
    style: styles["".concat(PREFIX, "-btn")],
    onPress: onClickViewMore
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles["".concat(PREFIX, "-btn-text")]
  }, viewMoreText), /*#__PURE__*/React.createElement(ArrowDown, {
    style: styles["".concat(PREFIX, "-arrow")]
  }))) : /*#__PURE__*/React.createElement(FAQList, {
    disabledFaq: disabledFaq,
    PREFIX: PREFIX,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack = props.componentTrackingData) === null || _props$componentTrack === void 0 ? void 0 : _props$componentTrack.faq,
    isUIOptimisationRecommender: isUIOptimisationRecommender
  }), /*#__PURE__*/React.createElement(Popup, {
    showCloseIcon: true,
    contentContainerStyle: _objectSpread(_objectSpread({}, styles["".concat(PREFIX, "-popup-content-container")]), {}, {
      height: isAutoAdapt ? 'auto' : '80%'
    }),
    contentStyle: styles["".concat(PREFIX, "-popup-content")],
    active: showPopup,
    onClose: onClosePopup,
    contentScrollable: false
  }, /*#__PURE__*/React.createElement(Animated.ScrollView, _extends({
    style: styles["".concat(PREFIX, "-detail-content")],
    ref: scrollViewRef,
    scrollEventThrottle: 16,
    onScrollBeginDrag: function onScrollBeginDrag() {
      return scrollY.stopAnimation();
    },
    onLayout: function onLayout() {
      emitTrackingEvent(KEY_ANSWER_TRACKER_SCOPE);
    },
    onScroll: function onScroll() {
      emitTrackingEvent(KEY_ANSWER_TRACKER_SCOPE);
    },
    overScrollMode: "never",
    scrollEnabled: Platform.OS === 'android' ? scrollEnabled : true
  }, panResponder.panHandlers), /*#__PURE__*/React.createElement(View, {
    onStartShouldSetResponder: function onStartShouldSetResponder() {
      return true;
    }
  }, /*#__PURE__*/React.createElement(RichTextInWebView, {
    content: summary,
    className: "supporting-message key-answer-detail",
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    onClose: onClosePopup,
    defaultWidth: Dimensions.get('window').width,
    needScrollToUnread: showPopup && isScrollToUnread,
    unreadObj: unreadObj,
    exceededMaxHeight: exceededMaxHeight,
    handleScroll: function handleScroll(val) {
      setScrollHeight(val);
    },
    webViewKey: webViewKey,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      expand: true
    },
    haveMinRichTextWidth: haveMinRichTextWidth
  }), supportingMessage ? /*#__PURE__*/React.createElement(RichTextInWebView, {
    content: supportingMessage,
    className: "supporting-message key-answer-detail",
    articleContentTrackingData: closePopupTracking !== null && closePopupTracking !== void 0 && closePopupTracking.trackingdataBasic ? _objectSpread(_objectSpread({}, closePopupTracking === null || closePopupTracking === void 0 ? void 0 : closePopupTracking.trackingdataBasic), {}, {
      trackingsection: TRACKING_SECTION.keyAnswerDetail
    }) : undefined,
    changeTrackCloseArticleContentData: changeTrackClosePopupData,
    onClose: onClosePopup,
    defaultWidth: Dimensions.get('window').width,
    webViewKey: webViewKey,
    isUIOptimisationButton: isUIOptimisationButton,
    accordionOptions: {
      isUIOptimisationAccordion: isUIOptimisationAccordion,
      expand: true
    },
    isUIOptimisationTableModal: isUIOptimisationTable,
    haveMinRichTextWidth: haveMinRichTextWidth,
    handleDisabledScroll: handleDisabledScroll,
    richTextTouchEnd: handleRichTextTouchEnd
  }) : null, /*#__PURE__*/React.createElement(FAQList, {
    disabledFaq: disabledFaq,
    PREFIX: PREFIX,
    faqTitle: faqTitle,
    faqIntentList: faqIntentList,
    onClickFaq: onClickFaq,
    trackingData: (_props$componentTrack2 = props.componentTrackingData) === null || _props$componentTrack2 === void 0 ? void 0 : _props$componentTrack2.faqInDetail,
    styles: _objectSpread({}, styles["".concat(PREFIX, "-faq-container-top12")]),
    isUIOptimisationRecommender: isUIOptimisationRecommender,
    inDetail: true
  })))));
};